import React  from 'react';
import { add, compose, isNil, toUpper } from 'ramda';
import { connect } from 'react-redux';
import { List, Map, OrderedMap } from 'immutable';
import moment from 'moment';

import styleFile from './AvailServiceDetail.js';
import RichText from '@synergycms_core/components/generic/RichText';
import { Image, Button } from '@synergycms_core/components/generic/';

import { roomCanAddService, boardCanAddService } from '../../../store/avail/availUtils';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';

import Price from '@synergycms_core/components/generic/Price';
import actions from '../../../store/actions';

import AvailServiceRoomDetailWithQuota from './AvailServiceRoomDetailWithQuota.jsx';
import AvailServiceRoomDetail from './AvailServiceRoomDetail.jsx';

import {
  SERVICE_TYPE_PER_NIGHT,
  SERVICE_TYPE_PER_PERSON,
  SERVICE_TYPE_PER_PERSON_NIGHT,
  SERVICE_TYPE_PER_STAY,
  SERVICE_TYPE_PER_USE,
  SERVICE_PER_NIGHT_TYPES
} from '../../../config/constants';

import { addServiceByTime } from '../../../utils/services.js';

const ServiceDetailHeader = compose(
  withThemeJSS({ styleFile, link: true })
)(class ServiceDetailHeader extends React.Component {

  constructor(props) {
    super(props);
    
    this.state = {
      descriptionBlock: false,
      showMoreButton: false,
      width:null
    };
    this.widthRef = React.createRef();
  }

  componentDidMount(prevProps, prevState, snapshot) {
    if ( this.refs.serviceDescriptionText.clientHeight > this.refs.serviceImageContainer.clientHeight) {
      this.setState(state => ({
        showMoreButton: true,
        width: this.props.theme.getDesirableWidth(
          this.widthRef.current?.offsetWidth, 
          this.widthRef.current?.offsetHeight
        )
      }));
    }
  }

  toggleServiceDescription = () => e => {
    e.preventDefault();
    this.setState((state, props) => ({
      descriptionBlock: !state.descriptionBlock
    }));
  };


  render() {
    const classes = this.props.classes;
    const resizableImages = this.props.resizableImages && this.state.width ? this.state.width : '';

    return (
      <div className={classes.serviceHeader}>
        <div className={this.props.hasImage ? classes.positionImage : classes.hide} ref={this.props.hasImage ? this.widthRef : null}>
          <Image
              innerStyle={'backgroundImageBase'}
              src={this.props.serviceImage + resizableImages}
              loading={"lazy"}
              onError={this.onErrorServiceImage}
              alt={this.props.serviceName}
          />
        </div>
        <div
          className={this.props.hasImage ? classes.serviceInfoWithImage : classes.serviceInfo}
          ref={'serviceDescriptionContainer'}>
          <RichText text={this.props.serviceName} innerStyle={['titleHeader']} />
          <span className={classes.titleSpace} />
          <div ref={'serviceImageContainer'} className={this.state.descriptionBlock ? [classes.showMoreButton] : classes.showLessButton}>
            <div ref={'serviceDescriptionText'}>
              <RichText
                dangerouslySetInnerHTML={this.props.description}
                innerStyle={['roboto13Black', 'promoDescription']}
              />
            </div>
          </div>
          <div className={this.state.descriptionBlock || !this.state.showMoreButton ? classes.showMoreNoShadow : classes.showMoreShadow}>
            <Button
              onClick={this.toggleServiceDescription()}
              richText={{
                text: this.state.descriptionBlock ? '_%ocultar%_' : '_%leer más%_',
                ucFirst: true,
                innerStyle: ['roboto13Gold'],
                rightIcon: {
                  unicodeContent: this.state.descriptionBlock ? 'e02e' : 'e0f8',
                  innerStyle: ['mainColor', 'size12', 'marginLeft5']
                },
                translate: true
              }}
              innerStyle={this.state.showMoreButton ? [] : ['hide']}
            />
          </div>
        </div>
      </div>
    );
  }
});

const AddServiceButton = (props) => {
  const { classes, serviceSelected, langCode, toggleService } = props;

  return (
    <div className={serviceSelected ? [classes.hide] : [classes.serviceBookButton]}>
      <Button
        onClick={toggleService()}
        richText={{
          text: '_%lo quiero%_',
          ucFirst: true,
          innerStyle: ['toggleSecondButton'],
          rightIcon: { unicodeContent: langCode === 'AR' ? '005C' : 'e000', innerStyle: ['size12', 'marginLeft5'] },
          translate: true
        }}
        innerStyle={['toggleSecondButton']}
      />
    </div>
  );
}

const DeleteServiceButton = props => (
  <div className={props.classes.deleteService}>
    <Button
      onClick={props.toggleService()}
      richText={{
        text: '_%eliminar%_',
        innerStyle: ['roboto16BoldGold', 'capitalize'],
        icon: { unicodeContent: 'e08a', innerStyle: ['size20', 'marginRight5'] },
        translate: true
      }}
      innerStyle={props.serviceSelected ? [''] : ['hide']}
    />
  </div>
);

const getServiceTypeText = serviceType => {
  let serviceTypeText;

  switch (serviceType) {
    case SERVICE_TYPE_PER_STAY:
      serviceTypeText = '_%por estancia%_';
      break;
    case SERVICE_TYPE_PER_NIGHT:
      serviceTypeText = '_%por noche%_';
      break;
    case SERVICE_TYPE_PER_PERSON:
    case SERVICE_TYPE_PER_PERSON_NIGHT:
      serviceTypeText = '_%por persona%_';
      break;
    case SERVICE_TYPE_PER_USE:
      serviceTypeText = '_%por uso%_';
      break;
    default:
      serviceTypeText = '';
      break;
  }
  return {text : serviceTypeText};
};

const forceTextPerStay = (service) => {
  const serviceType = service.get('type').toUpperCase();
  
  /* 
    Si el servicio no tiene quota y es por noche le cambiamos el texto a Por estancia ya que el precio que mostramos en el detalle del servicio
    es el precio total de todas las noches , en cambio cuando es con cupo, el por noche solo mostrará el precio de una sola noche, esto basicamente es para mantener
    la funcionalidad que se tenía antes de implementar el cupo en los suplementos
  */
  if(serviceType === SERVICE_TYPE_PER_NIGHT || serviceType === SERVICE_TYPE_PER_PERSON_NIGHT){
    return true;
  }

  /*
    Esto estaba así antes de implementar el cupo en los suplementos, si el servicio tiene precio por niño, siempre se mostrará por estancia
    lo mantengo para la compatibilidad
  */
  if(service.get('has_price_per_child', false)){
    return true;
  }

  return false;
}

class AvailServiceDetail extends React.Component {
  static displayName = 'AvailServiceDetail';
  constructor(props) {
    super(props);

    const service = this.props.config.service;
    this.serviceBlocks = OrderedMap();
    this.addService = this.props.config.addService.bind(this);
    this.removeService = this.props.config.removeService.bind(this);
    this.props.config.reservationBlocks.forEach(block => {
      const serviceKey = block
        .get('services')
        .findIndex(s => service.get('id') === s.get('service_id'));
      if (serviceKey !== -1) {
        this.serviceBlocks = this.serviceBlocks.set(block.get('idx'), block.getIn(['services', serviceKey]));
      }
    });

    this.state = {
    };

    this.enableCalendar = (
      (
        service.get("works_with_quota") &&  !SERVICE_PER_NIGHT_TYPES.includes(toUpper(service.get('type')))
      ) ||
      service.get("works_with_quota_time")
    );
  }

  toggleService = () => e => {
    e && e.preventDefault();

    const serviceSelected = !this.props.config.serviceSelected;

    const {
      reservationBlocks,
      service,
      addServiceByTime: addServiceByTimeAction
    } = this.props.config;

    const eventName = serviceSelected ? 'add_service' : 'del_service';
    this.props.config.triggerEvent(eventName, service.toJS());

    const serviceType = service.get('type').toUpperCase();
    const isPerNightType = SERVICE_PER_NIGHT_TYPES.includes(serviceType);
    
    if(service.get('works_with_quota') && isPerNightType) {
        const reservation = this.props.config.reservationRequest;
        const removeServiceByTime = this.props.config.removeServiceByTime;
        const checkin = reservation.get('checkin');
        const checkout = reservation.get('checkout');
        const numberOfNights = moment(checkout).diff(moment(checkin), 'days');

        for (let i = 0; i < numberOfNights; i++) {
          const date = moment(checkin).add(i, 'days').format('YYYY-MM-DD');
          reservationBlocks.forEach(block => {
            if(serviceSelected) {
              this.serviceBlocks = this.serviceBlocks.set(
                block.get('idx'),
                addServiceByTime(
                  block.get('idx'), 
                  service,
                  reservationBlocks, 
                  moment(date), 
                  addServiceByTimeAction
                )
              );
            } else {
              removeServiceByTime(
                block.get('idx'), 
                service.get('id'), 
                Map({ 
                  day: moment(date).format('YYYY-MM-DD'), 
                  time: false 
                })
              );
            }
          });
        }

    } else {
      if (serviceSelected) {
        reservationBlocks.forEach(block => {
          if (roomCanAddService(service)(block) && boardCanAddService(service)(block)) {
            this.serviceBlocks = this.serviceBlocks.set(
              block.get('idx'),
              Map({ service_id: service.get('id'), price: service.get('price'), quantity: 1 })
            );
          }
        });
      } else {
        this.serviceBlocks = OrderedMap();
      }

      serviceSelected
      ? this.addService(this.serviceBlocks)
      : this.removeService(
        reservationBlocks.reduce(
          (result, block) => result.set(block.get('idx'), Map({ service_id: service.get('id') })),
          OrderedMap()
        )
      );
    }
  };

  changeServiceQuantity = idx => e => {
    let eventName;
    const { service, triggerEvent } = this.props.config;

    const value = parseInt(e.currentTarget.value, 10);
    if (value > 0) {
      eventName = 'add_service';
      if (this.serviceBlocks.getIn([idx, 'service_id']) !== service.get('id')) {
        this.serviceBlocks = this.serviceBlocks.set(
          idx,
          Map({ service_id: service.get('id'), price: service.get('price'), quantity: value })
        );
      } else {
        this.serviceBlocks = this.serviceBlocks.setIn([idx, 'quantity'], value);
      }
      this.addService(this.serviceBlocks);
    } else {
      eventName = 'del_service';
      const reservationBlocks = this.props.config.reservationBlocks,
        service = this.props.config.service;
      this.removeService(
        reservationBlocks.reduce((result, block) => {
          if (idx === block.get('idx')) {
            result = result.set(idx, Map({ service_id: service.get('id') }));
            this.serviceBlocks = this.serviceBlocks.set(idx, Map());
          } else {
            result = result.set(block.get('idx'), Map());
          }
          return result;
        }, OrderedMap())
      );
    }

    triggerEvent(eventName, service.toJS(), value);
  };

  changeBlockService = (idx, value) => e => {
    this.setRoom(idx);
    
    const serviceSelected = !value;
    const { service } = this.props.config;

    const worksWithQuota = service.get("works_with_quota");

    if(!worksWithQuota || (worksWithQuota && SERVICE_PER_NIGHT_TYPES.includes(toUpper(service.get('type'))))) {
      if (serviceSelected) {
        if(worksWithQuota) {
          this.addServiceNightByTime(idx, service);
        } else {
          this.addService(this.serviceBlocks);
        }
      } else {
        this.serviceBlocks = this.serviceBlocks.remove(idx);
        this.removeService(OrderedMap().set(idx, Map({ service_id: service.get('id') })));
      }
    } else {
      if(!value){
        this.serviceBlocks = this.serviceBlocks.remove(idx);
        this.removeService(OrderedMap().set(idx, Map({ service_id: service.get('id') })));
      }
    }

  };

  addServiceNightByTime =  (idx, service) => {
    const {
      reservationBlocks,
      reservationRequest:reservation,
      addServiceByTime: addServiceByTimeAction
    } = this.props.config;

    const checkin = reservation.get('checkin');
    const checkout = reservation.get('checkout');
    const numberOfNights = moment(checkout).diff(moment(checkin), 'days'); 
    
    for (let i = 0; i < numberOfNights; i++) {
      const date = moment(checkin).add(i, 'days').format('YYYY-MM-DD');
      this.serviceBlocks = this.serviceBlocks.set(
        idx,
        addServiceByTime(
          idx, 
          service,
          reservationBlocks, 
          moment(date), 
          addServiceByTimeAction
        )
      );
    }
  }

  toggleCalendar = (visible) => e =>{
    this.setState({
      visible : !isNil(visible) ? visible : !this.state.visible,
    });
  }

  setRoom = (roomBlockIdx)=> e => {
    const {service} = this.props.config;
    if(service.get("works_with_quota") || service.get("works_with_quota_time")) {
        this.state({currentRoom : roomBlockIdx}); 
    }
  };

  render() {
    const { config, theme } = this.props;
    const { 
      showTaxes, 
      reservationBlocks, 
      serviceSelected, 
      service, 
      totalAdults, 
      totalChildren,
      selectionAvail
    } = config;
    const serviceType = service.get('type').toUpperCase();
    const { classes } = theme.styles;
    const description = service.get('description');
    const serviceImage = service.get('image');
    const hasImage = serviceImage && serviceImage.length > 0;
    const totalSegments = reservationBlocks.size;
    const showRoomsDetail = serviceSelected && (serviceType === SERVICE_TYPE_PER_USE || totalSegments > 1);
    const serviceTypeText = forceTextPerStay(service) ? getServiceTypeText(SERVICE_TYPE_PER_STAY) : getServiceTypeText(serviceType);
    
    
    let servicePrice = showTaxes ? service.get('price_tax') : service.get('price');
    
    let realChilds = totalChildren;

    reservationBlocks.forEach((block) => {
      realChilds -= block.get('babies', 0);
    });

    if(service.get('has_price_per_child', false) === true) {
      let adults = 0;
      let children = 0;
      let someBookedService = false;
      reservationBlocks.forEach((block) => {
        let bookedService =
          block.get('services').find(s => s.get('service_id') === service.get('id')) || false;
          if(bookedService) {
              someBookedService = true;
              adults += block.get('adults', 0);
              children += block.get('childs', 0);
          }
      });

      let serviceChildPrice = showTaxes ? service.get('child_price_tax', 0) : service.get('child_price', 0);
      if(someBookedService !== false) {
        servicePrice = (servicePrice * adults) + (serviceChildPrice * children);
      } else {
        servicePrice = (servicePrice * totalAdults) + (serviceChildPrice * realChilds);
      }
    }


    // Si no es un por noche, el precio que se muestra es singular por uso, por lo tanto hay que buscar el precio mas bajo de todos los dias
    let hasVariantPrice = false;
    const priceKey = showTaxes ? 'price_tax' : 'price';
    if (!SERVICE_PER_NIGHT_TYPES.includes(serviceType)) {
      servicePrice = service.get('days', List()).reduce((accum, v) => {
        const price = v.get(priceKey);
        if (price !== accum) hasVariantPrice = true;
        return accum < price ? accum : price;
      }, servicePrice);
    } else if (serviceType === SERVICE_TYPE_PER_PERSON_NIGHT && service.get('has_price_per_child', false) === false) {
      servicePrice = servicePrice * (totalAdults + totalChildren);
    }

    return (
      <div className={theme.computedInnerStyle}>
        <ServiceDetailHeader
          classes={classes}
          hasImage={hasImage}
          serviceImage={serviceImage}
          description={description}
          serviceName={service.get('name')}
          resizableImages={theme.resizableImages}
        />
        <div className={classes.serviceFooter}>
          <div className={classes.firstRowFooter}>
            {this.enableCalendar ? (
              <>
              <AvailServiceRoomDetailWithQuota
                service={service}
                serviceSelected={serviceSelected}
                reservationBlocks={reservationBlocks}
                showRoomsDetail={showRoomsDetail}
                changeBlockService={this.changeBlockService}
                changeServiceQuantity={this.changeServiceQuantity}
                serviceBlocks={this.serviceBlocks}
                hasVariantPrice={hasVariantPrice}
                servicePrice={servicePrice}
                serviceTypeText={serviceTypeText}
                langCode={config.langCode}/>
              </>
            ):(
              <>
              <div className={showRoomsDetail ? classes.roomsDetail : classes.hide}>
                {reservationBlocks.map(block => (
                  <AvailServiceRoomDetail
                    key={block.get('idx')}
                    classes={classes}
                    service={service}
                    block={block}
                    serviceType={serviceType}
                    changeServiceQuantity={this.changeServiceQuantity}
                    changeBlockService={this.changeBlockService}
                    serviceBlocks={this.serviceBlocks}/>
                ))}
              </div>
              <div className={classes.secondRowFooter}>
              <div className={serviceSelected ? '' : classes.hide}>
                <DeleteServiceButton
                  classes={classes}
                  toggleService={this.toggleService}
                  serviceSelected={serviceSelected}
                />
              </div>
              <div className={[classes.servicePrice, serviceSelected ? classes.servicePriceSelected : ''].join(' ')}>
                {!SERVICE_PER_NIGHT_TYPES.includes(serviceType) && hasVariantPrice ? (
                  <RichText
                  text={'_%desde%_'}
                  ucFirst={true}
                  innerStyle={['roboto11SoftGray', 'accesabilityGray']}
                  translate={true}
                  />
                ):null}
                <Price innerStyle={['boldPrice']} amount={servicePrice} />
                <RichText
                  text={serviceTypeText.text}
                  ucFirst={true}
                  innerStyle={['roboto11SoftGray', 'accesabilityGray']}
                  translate={true}
                />
              </div>
              <AddServiceButton 
                classes={classes} 
                toggleService={this.toggleService} 
                serviceSelected={serviceSelected} 
                langCode={config.langCode} />
            </div>
            </>
            )}
          </div>
        </div>
      </div>
    );
  }
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    addService: serviceBlocks => {
      dispatch(actions.customer.reservationRequest.addService(serviceBlocks));
    },
    addServiceByTime: serviceBlocks => {
      dispatch(actions.customer.reservationRequest.addServiceByTime(serviceBlocks));
    },
    removeService: serviceBlocks => {
      dispatch(actions.customer.reservationRequest.removeService(serviceBlocks));
    },
    removeServiceByTime: (idx, serviceId, date) => {
      dispatch(actions.customer.reservationRequest.removeServiceByTime(idx, serviceId, date));
    },
    triggerEvent: (name, service, count = 1) => {
      dispatch(actions.events.trigger(name, { service, count }));
    }
  };
};

const mapStateToProps = (store, ownProps) => {
  const hotelId = store.getIn(['customer', 'current_hotel']);
  const queryParams = store.getIn(['hotels', hotelId, 'params', 'params']);
  const hotelInfo = store.getIn(['hotels', hotelId]);
  const reservation = store.getIn(['customer', 'reservation_request']);
  const reservationBlocks = reservation.get('blocks');
  const service = ownProps.service;
  const guests = queryParams.get('occups');
  const selectionAvail = store.getIn(['customer', 'selection_avail']);

  return {
    showTaxes: hotelInfo.get('show_taxes'),
    reservationBlocks: reservationBlocks,
    reservationRequest: reservation,
    serviceSelected: reservationBlocks.some(block =>
      block.get('services').find(s => s.get('service_id') === service.get('id'))
    ),
    langCode: store.getIn(['customer', 'lang_info', 'code']),
    totalAdults: guests.map(s => s.get('adults')).reduce((accum, v) => add(v, accum), 0) || 0,
    totalChildren: guests.map(s => s.get('childs') || 0).reduce((accum, v) => add(v, accum), 0) || 0,
    selectionAvail
  };
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  PropertyManager([
    'service',
    'showTaxes',
    'totalSegments',
    'reservationBlocks',
    'reservationRequest',
    'addService',
    'removeService',
    'triggerEvent',
    'serviceSelected',
    'totalAdults',
    'totalChildren',
    'langCode',
    'addServiceByTime',
    'removeServiceByTime',
    'selectionAvail'
  ]),
  withThemeJSS({ styleFile, link: true })
)(AvailServiceDetail);